<template>
  <div class="view">
    <div class="content contentBody">
      <div class="pagelist-title">
        默认展示
      </div>
      <div class="pagelist-body" v-if="posterInfo">
        <el-row class="pagelist-body-row">
          <el-col :span="4">
          </el-col>
          <el-col :span="20">
            <div>
              <uploadImg @getChildValue="getChildValue" imgNumber="1" page="startUp"
                         :picSrc="posterInfo.guide_poster"></uploadImg>
            </div>
            <div class="pagelist-body-right-r">
              在没有特殊日期时展示的默认启动图，上传的图片尺寸建议为1080*1620，大小不超过3M <span @click="viewImgDialog('viwe')">预览</span>
            </div>
          </el-col>
        </el-row>
        <el-row class="pagelist-body-row">
          <el-col :span="4" class="pagelist-body-left">
            点击图片的跳转地址:
          </el-col>
          <el-col :span="20" class="pagelist-body-right">
            <el-input v-model="posterInfo.link_url" placeholder="请输入跳转地址"></el-input>
          </el-col>
        </el-row>
        <el-row class="pagelist-body-row">
          <el-col :span="4" class="pagelist-body-left">
            APP是否展示启动页:
          </el-col>
          <el-col :span="20" class="pagelist-body-right">
            <el-switch
              v-model="posterInfo.enable_guide_poster"
              active-color="#2AA3F8"
              inactive-color="#ddd"
              >
            </el-switch>
          </el-col>
        </el-row>
        <el-row class="pagelist-body-row ">
          <el-col :span="4">
          </el-col>
          <el-col :span="20" class="pagelist-body-right">
            <el-checkbox v-model="checked">同意</el-checkbox>
            <span @click="gotoRuleFn" class="rule-check">《企业开机启动规则》</span>
          </el-col>
        </el-row>
        <el-row class="pagelist-body-row button-list-row">
          <el-col :span="4">
          </el-col>
          <el-col :span="20" class="pagelist-body-right">
            <el-button type="primary" @click="saveSubmitLine(1)" size="small">保存</el-button>
            <!--<el-button @click="saveSubmitLine(2)">清除</el-button>-->
          </el-col>
        </el-row>
      </div>
      <div class="pagelist-title">
        自定义日期展示
      </div>
      <div class="pagelist-body">
        <div class="addDateSetting-list">
          设定在企业纪念日、重大通知时展示的启动画面
          <el-button @click="statusDialogFn(1)" size="small">添加</el-button>
        </div>
        <div v-if="posterList.length!==0">
          <div class="addDateSetting-list-line" v-for="(item,index) in posterList" :key="index">
            <div class="addDateSetting-list-line-li">
              <span>{{item.name}}</span>
            </div>
            <div class="addDateSetting-list-line-l">
              <div class="checkImgDialog"
                   :style="{backgroundImage:'url('+item.guide_poster+')',backgroundSize:'cover',backgroundPosition:'center'}"
                   @click="viewImgDialog(index)">
                <div class="imgpreviewBody">
                  <div class="imgpreview">
                    <i class="el-icon-view"></i>
                  </div>
                </div>
              </div>
              <!--<img :src="item.guide_poster"-->
              <!--alt=""-->
              <!--width="60"-->
              <!--height="60">-->
              <span>{{item.start_date+' - '+item.end_date}}</span>
            </div>
            <div class="addDateSetting-list-line-r">
              <span @click="statusDialogFn(2,index)">编辑</span>
              <span @click="statusDialogFn(3,index)">删除</span>
            </div>
          </div>
        </div>
      </div>
      <el-dialog
              title="添加节日启动页"
              :visible.sync="dialogVisible"
              :close-on-click-modal="false"
              :close-on-press-escape="false"
              :before-close="beforeCloseFn"
              width="50%">
        <div class="pagelist-body">
          <el-row class="pagelist-body-row">
            <el-col :span="4"></el-col>
            <el-col :span="20">
              <div>
                <uploadImg @getChildValue="getChildValueAdd" imgNumber="1" page="startUp"
                           :picSrc="addimgpic"></uploadImg>
              </div>
              <div class="pagelist-body-right-r">
                在没有特殊日期时展示的默认启动图，上传的图片尺寸建议为1080*1620，大小不超过3M <span @click="viewImgDialog('edit')">预览</span>
              </div>
            </el-col>
          </el-row>
          <el-row class="pagelist-body-row">
            <el-col :span="4" class="pagelist-body-left">
              节日名称:
            </el-col>
            <el-col :span="20" class="pagelist-body-right">
              <el-input v-model="postername" placeholder="节日名称"></el-input>
            </el-col>
          </el-row>
          <el-row class="pagelist-body-row">
            <el-col :span="4" class="pagelist-body-left">
              点击图片的跳转地址:
            </el-col>
            <el-col :span="20" class="pagelist-body-right">
              <el-input v-model="addUrl" placeholder="请输入跳转地址"></el-input>
            </el-col>
          </el-row>
          <el-row class="pagelist-body-row">
            <el-col :span="4" class="pagelist-body-left">
              展示日期区间:
            </el-col>
            <el-col :span="20" class="pagelist-body-right">
              <el-date-picker
                      v-model="value1"
                      type="datetimerange"
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                      :picker-options="expireTimeOption">
              </el-date-picker>
            </el-col>
          </el-row>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="beforeCloseFn" size="small">取消</el-button>
          <el-button type="primary" @click="submitCloseFn" size="small">提交</el-button>
        </span>
      </el-dialog>
    </div>
    <!--viewImgDialog.vue-->
    <viewImgDialog :privaImgObj="imgsrcCheck" :visible.sync="dialogImgVisible"></viewImgDialog>
  </div>
</template>
<script>
  import viewImgDialog from "@/components/dialog/viewImgDialog.vue";
  import uploadImg from "@/components/dialog/uploadImg.vue";
  import api from "@/api.js";

  export default {
    name: "miniappPannel",
    components: {
      viewImgDialog,
      uploadImg
    },
    data() {
      return {
        uploadImg: api.uploadTokenImg,
        data_: {token: sessionStorage.getItem("token")},
        dialogImgVisible: false,
        imgsrcCheck: null,
        imgpic: null,
        imgClickHttp: '',
        checked: false,
        dialogVisible: false,
        dialogType: 'add',
        value1: '',
        expireTimeOption: {
          disabledDate(date) {
            return date.getTime() <= Date.now()- 8.64e7;
          }
        },
        posterInfo: null,
        posterList: [],
        addimgpic: '',
        addUrl: '',
        editId: '',
        postername: ''
      };
    },
    created() {
      this.InitFn();
    },
    methods: {
      InitFn() {
        this.axios
            .post(api.companyadmin_get_poster, {})
            .then(response => {
              if (response.data.code == 0) {
                if(response.data.info){
                  this.checked = true
                }
                this.posterInfo = response.data.info;
                this.posterList = response.data.list;
              } else {
              }
            })
            .catch(response => {
            });
      },
      getChildValueAdd(option){
        this.addimgpic = option
      },
      getChildValue(option) {
        this.posterInfo.guide_poster = option
      },
      showCorpper() {
        this.corppervisible = true
      },
      handleAvatarSuccess(res, file) {
        this.posterInfo.guide_poster = res.path;
        this.loadingStatus.close();
      },
      beforeAvatarUpload(file) {
        const isLt2M = file.size / 1024 / 1024 < 10;
        if (!isLt2M) {
          this.$message.error("上传头像图片大小不能超过 10MB!");
        }
        this.loadingStatus = this.$loading({
          lock: true,
          text: '上传中',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.4)',
          customClass: 'fontColor'
        });
        return isLt2M;
      },
      addhandleAvatarSuccess(res, file) {
        this.addimgpic = res.path;
        this.loadingStatus.close();
      },
      viewImgDialog(index) {
        if (index === 'viwe') {
          if (!this.posterInfo.guide_poster) {
            this.$message.error("请上传默认展示图");
          } else {
            this.imgsrcCheck = this.posterInfo.guide_poster
            this.dialogImgVisible = true
          }
        } else if (index === 'edit') {
          this.imgsrcCheck = this.addimgpic
          this.dialogImgVisible = true
        } else {
          this.imgsrcCheck = this.posterList[index].guide_poster
          this.dialogImgVisible = true
        }
      },
      addbeforeAvatarUpload(file) {
        const isLt2M = file.size / 1024 / 1024 < 10;
        if (!isLt2M) {
          this.$message.error("上传图片大小不能超过 10MB!");
        }
        this.loadingStatus = this.$loading({
          lock: true,
          text: '上传中',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.4)',
          customClass: 'fontColor'
        });
        return isLt2M;
      },
      gotoRuleFn() {
        this.$router.push({name: "startUpRule"});
      },
      saveSubmitLine(type) {
        if (type === 1) {
          if (!this.posterInfo.guide_poster) {
            this.$message.error('请上传展示图');
            return
          }
          // if (!this.posterInfo.link_url) {
          //   this.$message.error('请填写跳转地址');
          //   return
          // }
          if (!this.checked) {
            this.$confirm('请先阅读同意企业开机启动规则！', '提示', {
              confirmButtonText: '确定',
              showCancelButton: false,
              type: 'warning'
            }).then(() => {

            }).catch(() => {
            });
          } else {
            let data_ = {
              guide_poster: this.posterInfo.guide_poster,
              link_url: this.posterInfo.link_url,
              enable_guide_poster: this.posterInfo.enable_guide_poster
            }
            this.axios
                .post(api.companyadmin_set_poster, data_)
                .then(response => {
                  if (response.data.code == 0) {
                    this.$message({
                      message: '设置成功',
                    });
                  } else {
                  }
                })
                .catch(response => {
                });
          }
        } else {
          this.imgClickHttp = '';
        }
      },
      statusDialogFn(type, index) {
        // type 1 添加 2 编辑 3删除
        let _this = this;
        if (type === 1) {
          this.dialogType = 'add';
          this.dialogVisible = !this.dialogVisible;
        } else if (type === 2) {
          this.dialogType = 'edit';
          this.value1 = [this.posterList[index].start_date, this.posterList[index].end_date];
          this.addimgpic = this.posterList[index].guide_poster;
          this.addUrl = this.posterList[index].link_url;
          this.editId = this.posterList[index].id;
          this.dialogVisible = !this.dialogVisible;
          this.postername = this.posterList[index].name
        } else if (type === 3) {
          this.$confirm('此操作将删除该展示图, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            _this.axios
                .post(api.companyadmin_poster_delete, {poster_id: this.posterList[index].id})
                .then(response => {
                  if (response.data.code == 0) {
                    _this.$message({
                      message: '删除成功!'
                    });
                    _this.posterList.splice(index, 1);
                  } else {
                  }
                })
                .catch(response => {
                });
          }).catch(() => {
          });
        }
      },
      beforeCloseFn() {
        this.dialogVisible = !this.dialogVisible;
        this.addimgpic = '';
        this.addUrl = '';
        this.value1 = '';
        this.editId = '';
      },
      submitCloseFn() {
        if (!this.addimgpic) {
          this.$message.error('请上传展示图');
          return
        }
        if (!this.postername) {
          this.$message.error('请填写节日名称');
          return
        }
        // if (!this.addUrl) {
        //   this.$message.error('请填写跳转地址');
        //   return
        // }
        if (!this.value1) {
          this.$message.error('请选择展示时间区间');
          return
        }
        let data_ = {
          guide_poster: this.addimgpic, // 引导页海报
          link_url: this.addUrl, // 引导页链接
          name: this.postername, // 节日名称
          start_date: this.value1[0],
          end_date: this.value1[1]
        }
        let addUrl_ = api.companyadmin_poster_add;
        if (this.dialogType === 'edit') {
          data_.poster_id = this.editId;
          addUrl_ = api.companyadmin_poster_edit;
        }
        this.axios
            .post(addUrl_, data_)
            .then(response => {
              if (response.data.code == 0) {
                this.$message({
                  message: '操作成功',
                });
                this.InitFn();
                this.dialogVisible = !this.dialogVisible;
                this.addimgpic = '';
                this.addUrl = '';
                this.value1 = '';
                this.editId = '';
                this.postername = '';
              } else {
              }
            })
            .catch(response => {
            });
      },
    }
  };
</script>
